// src/hooks/IssueboardIdUrlSync.tsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks";
import { setCurrentIssueboardId } from "./routes/issuesApp/issueSlice";
import { resetIssueBoardThunk } from "./routes/issuesApp/issueThunk";
// Anpassa dessa imports till din slice:

/** Plockar ut issueboardId från /project/:projectId/issues/:issueboardId */
const extractIssueboardId = (pathname: string): string | null => {
  // Ex: "/project/61f4.../issues/68b5..." -> "68b5..."
  const m = /^\/project\/[^/]+\/issues\/([^/]+)/.exec(pathname);
  return m?.[1] ?? null;
};

/** Mounta denna komponent högt upp (t.ex. i ProjectApp). Den renderar inget. */
const IssueboardIdUrlSync: React.FC = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const currentIssueBoardId = useAppSelector((state) => state.issueReducerNew.currentIssueBoardId);

  useEffect(() => {
    const id = extractIssueboardId(pathname);
    if (id !== currentIssueBoardId) {
      dispatch(resetIssueBoardThunk());
    }
    dispatch(setCurrentIssueboardId(id));
  }, [currentIssueBoardId, dispatch, pathname]);

  return null;
};

export default IssueboardIdUrlSync;
